/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Availabledates_Monday_May_1110Inputs */

const en__field__enum_availabledates_monday_may_1110 = /** @type {(inputs: _Field__Enum_Availabledates_Monday_May_1110Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday, May 11, 2026`)
};

const de__field__enum_availabledates_monday_may_1110 = /** @type {(inputs: _Field__Enum_Availabledates_Monday_May_1110Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montag, 11.05.2026`)
};

/**
* | output |
* | --- |
* | "Monday, May 11, 2026" |
*
* @param {_Field__Enum_Availabledates_Monday_May_1110Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_availabledates_monday_may_1110 = /** @type {((inputs?: _Field__Enum_Availabledates_Monday_May_1110Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Availabledates_Monday_May_1110Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_availabledates_monday_may_1110(inputs)
	return de__field__enum_availabledates_monday_may_1110(inputs)
});
export { _field__enum_availabledates_monday_may_1110 as "_field__enum_availableDates_MONDAY_MAY_11" }